const facilitiesConst = ['Anaheim-1314', 'Brea-1125'];
export default facilitiesConst;
